import { render, staticRenderFns } from "./PostingCardHeader.vue?vue&type=template&id=dba88d70"
import script from "./PostingCardHeader.vue?vue&type=script&lang=ts"
export * from "./PostingCardHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dba88d70')) {
      api.createRecord('dba88d70', component.options)
    } else {
      api.reload('dba88d70', component.options)
    }
    module.hot.accept("./PostingCardHeader.vue?vue&type=template&id=dba88d70", function () {
      api.rerender('dba88d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recruitings/postingComponents/PostingCardHeader.vue"
export default component.exports